import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  Grid,
  Link,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import headerIcon from "../../assets/images/header-face-icon.svg";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Instagram from "../../assets/images/social-icon-insta.svg";
import Twitter from "../../assets/icons/twitter-social-icon.svg";
import Discord from "../../assets/images/social-icon-discord.svg";
import EnigmaLogo from "../../assets/icons/enigma-logo-white.svg";

const Header = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const menuItems = (
    <>
      <Link sx={sxStyles.menuItem} href={"#beneficios-slider"}>
        <Typography sx={sxStyles.menuItemText}>BENEFICIOS</Typography>
      </Link>
      <Link sx={sxStyles.menuItem} href={"#how-to-play-slider"}>
        <Typography sx={sxStyles.menuItemText}>¿COMO SE JUEGA?</Typography>
      </Link>
      <Link sx={sxStyles.menuItem} href={"#collection-section"}>
        <Typography sx={sxStyles.menuItemText}>NIVELES</Typography>
      </Link>
      <Link sx={sxStyles.menuItem} href={"#faqs"}>
        <Typography sx={sxStyles.menuItemText}>FAQS</Typography>
      </Link>
    </>
  );

  const socialButtons = (
    <>
      <Button sx={sxStyles.socialButton}>
        <Link
          href={"https://www.instagram.com/bizarrapsocialclub"}
          target={"_blank"}
        >
          <img
            src={Instagram}
            style={{ height: "34px", width: "34px", marginRight: "10px" }}
          />
        </Link>
      </Button>
      <Button sx={sxStyles.socialButton}>
        <Link href={"https://discord.gg/TGF6yEMgkK"} target={"_blank"}>
          <img
            src={Discord}
            style={{ height: "34px", width: "34px", marginRight: "10px" }}
          />
        </Link>
      </Button>
      <Button sx={sxStyles.socialButton}>
        <Link href={"https://twitter.com/bzrpsocialclub"} target={"_blank"}>
          <img src={Twitter} style={{ height: "34px", width: "34px" }} />
        </Link>
      </Button>
    </>
  );
  return (
    <AppBar sx={sxStyles.mainContainer}>
      <Grid
        sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <img src={headerIcon} style={{ marginRight: "20px" }} />
        <Link href={"https://enigma.art"} target={"_blank"}>
          <img
            src={EnigmaLogo}
            style={{ width: "110px", height: "44px", marginRight: "15px" }}
          />
        </Link>
      </Grid>
      <Grid sx={sxStyles.mediaBox}>
        <Box sx={sxStyles.socialButtonsContainer}>{socialButtons}</Box>
        <Grid sx={sxStyles.navBox}>{menuItems}</Grid>
      </Grid>
      {!openDrawer && (
        <Button sx={sxStyles.menuButton} onClick={handleDrawerOpen}>
          <MenuIcon sx={sxStyles.menuIcon} />
          MENU
        </Button>
      )}
      <Backdrop
        sx={sxStyles.mobileMenu}
        open={openDrawer}
        onClick={handleDrawerClose}
      >
        <Stack sx={sxStyles.mobileMenuContainer}>
          <Toolbar sx={sxStyles.backdropHeader}>
            <img src={headerIcon} />
            <Button sx={sxStyles.closeButton}>
              <CloseIcon sx={sxStyles.closeIcon} />
              CLOSE
            </Button>
          </Toolbar>
          <Stack>
            {menuItems}
            <Grid sx={{ display: "flex", justifyContent: "space-around" }}>
              {socialButtons}
            </Grid>
          </Stack>
        </Stack>
      </Backdrop>
    </AppBar>
  );
};

export default Header;

const sxStyles = {
  mainContainer: {
    display: "flex",
    width: "100%",
    height: "90px",
    flexDirection: "row",
    justifyContent: {
      xs: "space-between",
      sm: "flex-start",
      md: "space-between",
    },
    alignItems: "center",
    paddingLeft: { xs: "20px", lg: "82px" },
    paddingRight: { xs: "20px", lg: "80px" },
    backgroundColor: "rgba(24,24,24,0.69)",
    zIndex: 1,
    position: "fixed",
    boxSizing: "border-box",
    right: 0,
    left: 0,
    top: 0,
  },
  mediaBox: {
    display: { xs: "none", sm: "flex" },
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  socialButtonsContainer: {
    marginRight: { sm: "10px", md: "48px" },
  },
  navBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  socialButton: {
    all: "unset",
    height: "34px",
    width: "34px",
    marginLeft: { sm: "10px", md: "24px" },
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "transparent",
    },
  },
  sectionButton: {
    marginRight: "32px",
    marginLeft: "32px",
    height: "34px",
    width: "90px",
    sm: { display: "none" },
  },
  menuItem: {
    marginLeft: { sm: "10px", md: "32px" },
    textDecoration: "none",
    marginBottom: { xs: "35px", sm: "0" },
  },
  menuItemText: {
    letterSpacing: "-0.7px",
    color: "white",
    fontWeight: "400",
    fontSize: { xs: "22px", sm: "16px", md: "20px" },
    lineHeight: "34px",
    fontFamily: "Dosis",
  },
  howToSectionButton: {
    marginRight: "32px",
    marginLeft: "32px",
    height: "34px",
    width: "200px",
    sm: { display: "none" },
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "transparent",
    },
  },
  sectionText: {
    color: "white",
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "34px",
    fontFamily: "Dosis",
    sm: { display: "none" },
  },
  menuButton: {
    display: { xs: "flex", sm: "none" },
    color: "white",
    fontWeight: "700",
    lineHeight: "34px",
    letterSpacing: "-0.7px",
    fontSize: "20px",
    padding: "8px 20px",
    backgroundColor: "#540A8D",
    borderRadius: "25px",
    justifyContent: "center",
    alignItems: "center",
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "transparent",
    },
  },
  menuIcon: {
    marginRight: "8px",
  },
  mobileMenu: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    zIndex: 100,
    width: "100%",
  },
  backdropHeader: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "90px",
    justifyContent: "space-between",
    padding: "0 20px",
    alignSelf: "stretch",
    marginBottom: "50px",
    boxSizing: "border-box",
  },
  mobileMenuContainer: { width: "100%" },
  closeButton: {
    color: "white",
    fontFamily: "Dosis",
    fontSize: "20px",
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "transparent",
    },
  },
  closeIcon: {
    height: "20px",
  },
};
